// src/pages/Login.js
import React, { useState } from 'react';
import './Homepage.css';
import '../components/HeaderButtons.css';
import logo from '../assets/logo.png';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { toast } from "react-toastify";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();
  const navigate = useNavigate();

  // تبديل عرض كلمة السر
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!selectedRole) {
      setError(language === 'ar' ? 'الرجاء اختيار الدور' : "الرجاء اختيار الدور");
      return;
    }

    if (!email || !password) {
      setError(language === 'ar' ? "الرجاء إدخال البريد الإلكتروني وكلمة المرور" : "الرجاء إدخال البريد الإلكتروني وكلمة المرور");
      return;
    }

    try {
      // محاولة تسجيل الدخول
      console.log('محاولة تسجيل الدخول...');
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log('تم تسجيل الدخول بنجاح:', userCredential);

      const user = userCredential.user;
      console.log('معلومات المستخدم:', {
        uid: user.uid,
        email: user.email,
        emailVerified: user.emailVerified
      });

      // التحقق من تفعيل البريد الإلكتروني
      if (!user.emailVerified) {
        console.log('البريد الإلكتروني غير مفعل');
        toast.warning("⚠️ يرجى تأكيد بريدك الإلكتروني أولاً قبل تسجيل الدخول.");
        return;
      }

      // التحقق من الدور
      console.log('التحقق من الدور:', selectedRole);
      let roleDoc;
      let roleExists = false;

      try {
        switch (selectedRole) {
          case 'admin':
            roleDoc = await getDoc(doc(db, 'admins', user.uid));
            roleExists = roleDoc.exists();
            console.log('نتيجة التحقق من دور المسؤول:', roleExists);
            if (roleExists) {
              localStorage.setItem('userRole', 'admin');
              navigate('/dashboard');
            }
            break;

          case 'restaurant':
            roleDoc = await getDoc(doc(db, 'restaurants', user.uid));
            roleExists = roleDoc.exists();
            console.log('نتيجة التحقق من دور المطعم:', roleExists);
            if (roleExists) {
              localStorage.setItem('userRole', 'restaurant');
              localStorage.setItem('restaurantId', user.uid);
              navigate('/restaurant/dashboard');
            }
            break;

          case 'driver':
            roleDoc = await getDoc(doc(db, 'drivers', user.uid));
            roleExists = roleDoc.exists();
            console.log('نتيجة التحقق من دور السائق:', roleExists);
            if (roleExists) {
              localStorage.setItem('userRole', 'driver');
              navigate('/driver/dashboard');
            }
            break;
        }

        if (!roleExists) {
          const errorMessage = selectedRole === 'admin' ? 
            "🚫 هذا الحساب غير مسجل كمسؤول" :
            selectedRole === 'restaurant' ? 
            "🚫 هذا الحساب غير مسجل كمطعم" :
            "🚫 هذا الحساب غير مسجل كسائق";
          toast.error(errorMessage + ". الرجاء التواصل مع الإدارة.");
        }
      } catch (roleError) {
        console.error('خطأ في التحقق من الدور:', roleError);
        toast.error("❌ حدث خطأ في التحقق من الدور. الرجاء المحاولة مرة أخرى.");
      }

    } catch (error) {
      console.error('خطأ في تسجيل الدخول:', {
        code: error.code,
        message: error.message,
        fullError: error
      });

      let errorMessage = "❌ خطأ في تسجيل الدخول";
      
      switch (error.code) {
        case 'auth/invalid-email':
          errorMessage = "❌ البريد الإلكتروني غير صالح";
          break;
        case 'auth/user-disabled':
          errorMessage = "❌ تم تعطيل هذا الحساب";
          break;
        case 'auth/user-not-found':
          errorMessage = "❌ لم يتم العثور على المستخدم";
          break;
        case 'auth/wrong-password':
          errorMessage = "❌ كلمة المرور غير صحيحة";
          break;
        case 'auth/too-many-requests':
          errorMessage = "❌ تم تجاوز عدد محاولات تسجيل الدخول. يرجى المحاولة لاحقاً";
          break;
        case 'auth/network-request-failed':
          errorMessage = "❌ خطأ في الاتصال بالشبكة";
          break;
        default:
          errorMessage = `❌ ${error.message}`;
      }
      
      toast.error(errorMessage);
      setError(errorMessage);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '14px',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box',
    backgroundColor: '#f9f9f9',
    textAlign: language === 'ar' ? 'right' : 'left',
    direction: language === 'ar' ? 'rtl' : 'ltr'
  };

  const roleButtonStyle = {
    flex: 1,
    padding: '10px',
    margin: '0 5px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease'
  };

  return (
    <div className="landing-page" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <header className="modern-header">
        <div className="header-content">
          <span className="app-title">AT Delivery</span>
          <button className="lang-switch-circle" onClick={toggleLanguage} title={language === 'ar' ? 'English' : 'العربية'}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff7e5f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20" />
              <path d="M12 2a15.3 15.3 0 0 1 0 20" />
              <path d="M12 2a15.3 15.3 0 0 0 0 20" />
            </svg>
          </button>
        </div>
      </header>
      <main>
        <div className="welcome-card" style={{maxWidth: 400}}>
          <h1 style={{marginBottom: 24}}>{t('login')}</h1>
          <form onSubmit={handleLogin}>
            {error && <p style={{ 
              color: '#dc3545', 
              textAlign: 'center', 
              margin: '0 0 16px',
              padding: '8px',
              backgroundColor: '#f8d7da',
              borderRadius: '6px',
              fontSize: '14px'
            }}>{error}</p>}

            <div style={{ marginBottom: '16px' }}>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                placeholder={t('email')}
                required 
                style={inputStyle}
              />
            </div>

            <div style={{ 
              position: 'relative', 
              marginBottom: '24px',
              width: '100%'
            }}>
              <input 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                placeholder={t('password')}
                required 
                style={inputStyle}
              />
              <div
                style={{
                  position: 'absolute',
                  left: language === 'ar' ? 'auto' : '12px',
                  right: language === 'ar' ? '12px' : 'auto',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  zIndex: 1
                }}
                onClick={togglePasswordVisibility}
                title={showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="#777" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  {showPassword ? (
                    // Eye icon with slash (hidden password)
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </>
                  ) : (
                    // Eye icon (visible password)
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </>
                  )}
                </svg>
              </div>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginBottom: '24px' 
            }}>
              {['admin', 'restaurant', 'driver'].map((role) => (
                <button
                  key={role}
                  type="button"
                  onClick={() => setSelectedRole(role)}
                  style={{
                    ...roleButtonStyle,
                    backgroundColor: selectedRole === role ? '#007bff' : '#f0f0f0',
                    color: selectedRole === role ? 'white' : '#333',
                    boxShadow: selectedRole === role ? '0 2px 6px rgba(0,123,255,0.3)' : 'none'
                  }}
                >
                  {role === 'admin' ? t('admin') :
                   role === 'restaurant' ? t('restaurant') :
                   t('driver')}
                </button>
              ))}
            </div>

            <button className="login-btn header-btn-login" type="submit">
              {t('login')}
            </button>
          </form>
          <div style={{marginTop: 16}}>
            <button className="register-btn header-btn-signup" onClick={() => navigate('/signup')}>
              {t('register')}
            </button>
          </div>
        </div>
      </main>
      <footer>
        <div className="footer-links">
          <a href="/privacy">{language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}</a>
          <span>|</span>
          <a href="/terms">{language === 'ar' ? 'الشروط والأحكام' : 'Terms of Service'}</a>
          <span>|</span>
          <a href="/return">{language === 'ar' ? 'سياسة الاسترجاع' : 'Return Policy'}</a>
          <span>|</span>
          <a href="/pricing">{language === 'ar' ? 'الأسعار' : 'Pricing'}</a>
          <span>|</span>
          <a href="/about">{language === 'ar' ? 'من نحن' : 'About Us'}</a>
          <span>|</span>
          <a href="/contact">{language === 'ar' ? 'اتصل بنا' : 'Contact Us'}</a>
          <span>|</span>
          <a href="/faq">{language === 'ar' ? 'الأسئلة الشائعة' : 'FAQ'}</a>
          <span>|</span>
          <a href="/guide">{language === 'ar' ? 'دليل المستخدم' : 'User Guide'}</a>
          <span>|</span>
          <a href="/features">{language === 'ar' ? 'الميزات' : 'Features'}</a>
          <span>|</span>
          <a href="/delete-account">{language === 'ar' ? 'حذف الحساب' : 'Delete Account'}</a>
        </div>
        <div className="footer-copy">
          {language === 'ar'
            ? 'جميع الحقوق محفوظة © AT Delivery 2025'
            : 'All rights reserved © AT Delivery 2025'}
        </div>
      </footer>
    </div>
  );
};

export default Login;
